import template from './inventory-header.html';

class InventoryHeaderController {
  backToSubordinatesList() {
    this.showSubordinates = !this.showSubordinates;
    this.retailer = {};
  }
}

export default class InventoryHeaderComponent {
  constructor() {
    this.controller = InventoryHeaderController;
    this.template = template;
    this.bindings = {
      showSubordinates: '=',
      retailer: '=',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/inventory-header/inventory-header-component.js